import React from 'react'
import ReactDOM from 'react-dom/client'
import { Auth0Provider } from '@auth0/auth0-react'
import App from './App.jsx'
import './index.css'
import { AuthProvider } from './contexts/AuthContext'
import AuthGuard from './components/AuthGuard'
import { logger } from './utils/logger'

const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN || 'dev-6w1mz1s2.us.auth0.com',
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || 'mHQqQqMlkeHmvOhSBSRM8275ywGb88EW',
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE || 'https://dev-6w1mz1s2.us.auth0.com/api/v2/',
    // offline_access habilita emissao de refresh tokens pelo Auth0
    // sem ele, useRefreshTokens: true causa redirect loop pois nao ha token para renovar
    scope: 'openid profile email offline_access'
  },
  // localStorage expõe tokens a XSS, mas é necessário para evitar redirect loop
  // quando useRefreshTokens: true e offline_access está no scope.
  // Trade-off aceito: XSS é mitigado via CSP estrita (Content-Security-Policy header
  // no Nginx + meta tag nos HTMLs) e Refresh Token Rotation está habilitado no Auth0.
  // Alternativa futura: cacheLocation: 'memory' + silent refresh via iframe.
  cacheLocation: 'localstorage',
  useRefreshTokens: true
};

logger.log('🔐 Auth0 Config:', {
  domain: auth0Config.domain,
  clientId: auth0Config.clientId,
  redirectUri: auth0Config.authorizationParams.redirect_uri
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Auth0Provider {...auth0Config}>
      <AuthProvider>
        <AuthGuard>
          <App />
        </AuthGuard>
      </AuthProvider>
    </Auth0Provider>
  </React.StrictMode>,
)
